import React, {FunctionComponent} from 'react';
import {useQuery} from '@tanstack/react-query';

import University from '../../../../../../networking/models/University';
import {
    useResponseWithoutPaginationQueryConfig
} from '../../../../../query/Response/Query';
import UniversityGeneralReviewsContent from './UniversityGeneralReviewsContent';
import { log } from 'console';

interface Props {
    university: University
}

// TODO: Replace with paginated responses
const UniversityGeneralReviews: FunctionComponent<Props> = (props) => {

    const [responseQueryConfig] = useResponseWithoutPaginationQueryConfig(props.university.id!);
    const responseQuery = useQuery(responseQueryConfig);
    

    if(responseQuery.data !== undefined) {
        if(responseQuery.data.length > 0) {
            const reviews = responseQuery.data.filter(x => x.comment != "");
            if(reviews.length > 0) {
                return (
                    <UniversityGeneralReviewsContent responses={reviews} />
                )
            }
        }        
    }
    return null
};

export default UniversityGeneralReviews;
